export const StateStatus = {
  idle: "idle",
  loading: "loading",
  failed: "failed",
} as const;

export type StateStatusType = (typeof StateStatus)[keyof typeof StateStatus];
